import React from "react";
import "./Pricing.css";
import tick from "./images/tick.png";
import untick from "./images/untick.png";


function Pricing() {
  return (
    <div className="pricing_outer" id="pricing">
      <div className="container">
        <div className="pricing_inner">
          <div className="pricing_heading">
            Pick a plan that’s right for you
          </div>
          <div className="pricing_pricebox_container">
            <div className="pricing_pricebox">
              <div className="pricing_basic">Silver</div>
              <div className="pricing_info">
                Individuals- Salary/House Property/Other Sources
              </div>
              <div className="pricing_price">
                Rs 2,499/- <br />
                <p>Inclusive of all taxes</p>
              </div>
              <div className="pricing_details">
                <ul>
                  <li>
                    <span className="icon-wrapper">
                      <img src={tick} alt="Included" className="list-icon" />
                    </span>
                    Salary Income
                  </li>
                  <li>
                    <span className="icon-wrapper">
                      <img src={tick} alt="Included" className="list-icon" />
                    </span>
                    Other Income -(Rental, Interest and Dividend)
                  </li>
                  <li>
                    <span className="icon-wrapper">
                      <img src={tick} alt="Included" className="list-icon" />
                    </span>
                    Tax Saving Advisory
                  </li>
                  <li>
                    <span className="icon-wrapper">
                      <img src={tick} alt="Included" className="list-icon" />
                    </span>
                    Investment Advisory
                  </li>
                  <li>
                    <span className="icon-wrapper">
                      <img src={untick} alt="Included" className="list-icon" />
                    </span>
                    Capital Gains
                  </li>
                  <li>
                    <span className="icon-wrapper">
                      <img src={untick} alt="Included" className="list-icon" />
                    </span>
                    Futures & Option (F&O)
                  </li>
                  <li>
                    <span className="icon-wrapper">
                      <img src={untick} alt="Included" className="list-icon" />
                    </span>
                    Expert Assisted Tax Filing- Online/Offline
                  </li>
                </ul>
              </div>
            </div>
            <div className="pricing_pricebox">
              <div className="pricing_basic pricing_gold">Gold</div>
              <div className="pricing_info">
                Individuals- Salary/House Property/Other Sources
              </div>
              <div className="pricing_price">
                Rs 5,499/- <br />
                <p>Inclusive of all taxes</p>
              </div>
              <div className="pricing_details">
                <ul>
                  <li>
                    <span className="icon-wrapper">
                      <img src={tick} alt="Included" className="list-icon" />
                    </span>
                    Salary Income
                  </li>
                  <li>
                    <span className="icon-wrapper">
                      <img src={tick} alt="Included" className="list-icon" />
                    </span>
                    Other Income -(Rental, Interest and Dividend)
                  </li>
                  <li>
                    <span className="icon-wrapper">
                      <img src={tick} alt="Included" className="list-icon" />
                    </span>
                    Tax Saving Advisory
                  </li>
                  <li>
                    <span className="icon-wrapper">
                      <img src={tick} alt="Included" className="list-icon" />
                    </span>
                    Investment Advisory
                  </li>
                  <li>
                    <span className="icon-wrapper">
                      <img src={tick} alt="Included" className="list-icon" />
                    </span>
                    Capital Gains
                  </li>

                  <li>
                    <span className="icon-wrapper">
                      <img src={untick} alt="Included" className="list-icon" />
                    </span>
                    Futures & Option (F&O)
                  </li>
                  <li>
                    <span className="icon-wrapper">
                      <img src={tick} alt="Included" className="list-icon" />
                    </span>
                    Expert Assisted Tax Filing- Online/Offline
                  </li>
                </ul>
              </div>
            </div>
            <div className="pricing_pricebox">
              <div className="pricing_basic pricing_pro">Platinum</div>
              <div className="pricing_info">
                For Self Employeed and Profession
              </div>
              <div className="pricing_price">
                Rs 7,499/- <br />
                <p>Inclusive of all taxes</p>
              </div>
              <div className="pricing_details">
                <ul>
                  <li>
                    <span className="icon-wrapper">
                      <img src={tick} alt="Included" className="list-icon" />
                    </span>
                    Salary Income
                  </li>
                  <li>
                    <span className="icon-wrapper">
                      <img src={tick} alt="Included" className="list-icon" />
                    </span>
                    Other Income -(Rental, Interest and Dividend)
                  </li>
                  <li>
                    <span className="icon-wrapper">
                      <img src={tick} alt="Included" className="list-icon" />
                    </span>
                    Tax Saving Advisory
                  </li>
                  <li>
                    <span className="icon-wrapper">
                      <img src={tick} alt="Included" className="list-icon" />
                    </span>
                    Investment Advisory
                  </li>
                  <li>
                    <span className="icon-wrapper">
                      <img src={tick} alt="Included" className="list-icon" />
                    </span>
                    Capital Gains
                  </li>

                  <li>
                    <span className="icon-wrapper">
                      <img src={tick} alt="Included" className="list-icon" />
                    </span>
                    Futures & Option (F&O)
                  </li>
                  <li>
                    <span className="icon-wrapper">
                      <img src={tick} alt="Included" className="list-icon" />
                    </span>
                    Expert Assisted Tax Filing- Online/Offline
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pricing;
